import './menu.scss';

const navItems = [
  { id: 'hero', label: 'Home' },
  { id: 'work', label: 'Work' },
  { id: 'about', label: 'About' },
  { id: 'contact', label: 'Contact' },
];

export default function Menu({ menuOpen, setMenuOpen }) {
  return (
    <nav className={`menu ${menuOpen ? 'is-open' : ''}`} aria-hidden={!menuOpen}>
      <ul className="menu__list">
        {navItems.map((item) => (
          <li key={item.id} className="menu__item">
            <a href={`#${item.id}`} onClick={() => setMenuOpen(false)}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="menu__footer">
        Arisa Nemoto · Tokyo, Japan
      </div>
    </nav>
  );
}
